"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Internal, extendable class for instatianting components.
 * Each compoment should contain functionality for a single DOM element or selector.
 */
var Component = function () {

  /**
   * Create a component
   *
   * @param {object} config - Options for the component
   * @param {string} config.name - Name of component, used in data-component attribute for instantiation and key for instance manifest
   * @param {Class}  config.class - ES6 class instance (should extend this class)
   * @param {object} config.querySelector - children of component's element of which there are only one
   * @param {object} config.querySelectorAll - children of component's element of which there are many
   * @param {object} config.options - arbitrary object of additional options
   * @param {object} config.children - selectors (defined as strings) you can query manually in the component
   */
  function Component(config) {
    var _this = this;

    _classCallCheck(this, Component);

    this.element = config.element;
    this.started = false;
    this.name = config.name;

    // Peripheral configuration properties
    this.options = config.options || {};
    this.children = config.children || {};

    // Query all children of which there is only one
    if (config.querySelector) {
      Object.keys(config.querySelector).forEach(function (elementKey) {
        _this.children[elementKey] = _this.element.querySelector(config.querySelector[elementKey]);
      });
    }

    // Query all children of which there are many
    if (config.querySelectorAll) {
      Object.keys(config.querySelectorAll).forEach(function (elementKey) {
        _this.children[elementKey] = _this.element.querySelectorAll(config.querySelectorAll[elementKey]);
      });
    }
  }

  /**
   * Destroy the component, removing the element from the dom and all attached event handlers
   */


  _createClass(Component, [{
    key: "destroy",
    value: function destroy() {
      // remove instance element from DOM
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Get the top offset of an element relative to a specific DOM node.
     *
     * @param {HTMLElement} el - Element for which you need the offset
     * @param {HTMLElement} context - Element relative to which the offset should be calculcated
     */

  }, {
    key: "getOffsetTop",
    value: function getOffsetTop(el, context) {
      return context === el ? 0 : el.offsetTop + this.getOffsetTop(el.parentElement, context);
    }

    /**
     * Check whether a node is a descendant of another node
     *
     * @param {HTMLElement} el - Element to check
     * @param {HTMLElement} context - Parent element to check against
     */

  }], [{
    key: "isChild",
    value: function isChild(el, context) {
      if (el) {
        var node = el.parentNode;

        while (node) {
          if (node === context) {
            return true;
          }
          node = node.parentNode;
        }
      }

      return false;
    }
  }]);

  return Component;
}();

exports.default = Component;


//////////////////
// WEBPACK FOOTER
// ./~/js-component-framework/lib/Component.js
// module id = ./node_modules/js-component-framework/lib/Component.js
// module chunks = 7